var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.313 7.031H4.688a2.344 2.344 0 00-2.344 2.344v9.375a2.344 2.344 0 002.344 2.344h15.625a2.344 2.344 0 002.343-2.344V9.375a2.344 2.344 0 00-2.343-2.344z",
    stroke: "#FF7D6B",
    strokeWidth: 1.563,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.086 7.031V5.567a2.442 2.442 0 00-2.898-2.398L4.328 5.364a2.441 2.441 0 00-1.984 2.4v2.392",
    stroke: "#FF7D6B",
    strokeWidth: 1.563,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.969 15.625a1.562 1.562 0 110-3.124 1.562 1.562 0 010 3.124z",
    fill: "#FF7D6B"
  })));
}
export default SvgWalletOutline;